import { useMusic } from '@/hooks/useMusic';
import { Music, Slash, Volume2, VolumeX } from 'lucide-react';
import { Button } from './ui/button';
import { cn } from '@/utils';

interface AudioControlsProps {
	className?: string;
	size?: 'default' | 'compact';
}

const baseControlButtonClass =
	'inline-flex items-center justify-center rounded-full border border-border/60 bg-card/70 p-0 text-foreground shadow-sm transition hover:border-primary/40 hover:bg-card/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-2 focus-visible:ring-offset-background';

export function AudioControls({ className, size = 'default' }: AudioControlsProps) {
	const { isMusicOn, toggleMusicOn, isGameSoundOn, toggleGameSound } = useMusic();
	const dimensionClass = size === 'compact' ? 'h-9 w-9' : 'h-11 w-11';
	const buttonClassName = cn(baseControlButtonClass, dimensionClass);

	const MusicIcon = ({ on }: { on: boolean }) =>
		on ? (
			<Music className="h-5 w-5" />
		) : (
			<span className="relative inline-flex size-5">
				<Music className="h-5 w-5" />
				<Slash className="absolute h-5 w-5 rotate-90" />
			</span>
		);

	const SoundIcon = ({ on }: { on: boolean }) => (on ? <Volume2 className="h-5 w-5" /> : <VolumeX className="h-5 w-5" />);

	return (
		<div className={cn('flex gap-2', className)}>
			<Button variant="ghost" aria-label={isMusicOn ? 'Disable music' : 'Enable music'} onClick={toggleMusicOn} className={buttonClassName}>
				<MusicIcon on={isMusicOn} />
			</Button>
			<Button
				variant="ghost"
				aria-label={isGameSoundOn ? 'Disable game sounds' : 'Enable game sounds'}
				onClick={toggleGameSound}
				className={buttonClassName}
			>
				<SoundIcon on={isGameSoundOn} />
			</Button>
		</div>
	);
}
